import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'

import { useInputValue } from '../../hooks/useInputValue'

import { InputText } from 'primereact/inputtext'
import { InputTextarea } from 'primereact/inputtextarea'
import { Button } from 'primereact/button'
import Switch from 'react-switch'
import Select from 'react-select'

import './styles.scss'

export const ProgramForm = ({
  item,
  courseListToEdit,
  courseList,
  isLoading,
  onSubmit,
  cancelLink,
}) => {
  const [selectedCourse, setSelectedCourse] = useState([])
  const [checked, setChecked] = useState(item !== null ? (item.status ? true : false) : false)
  const [coursesModified, setCoursesModified] = useState(false)


  const handleChange = (nextChecked) => {
    setChecked(nextChecked)
  }

  const name = useInputValue(
    {
      value: item ? item.name : '',
      name: 'Name',
      type: 'text',
      required: true,
      disabled: isLoading,
    },
    false
  )

  const { ...course } = useInputValue(
    {
      value: item ? item.course : '',
      name: 'course',
      disabled: isLoading,
    },
    false
  )

  const text = useInputValue(
    {
      value: item ? item.description : '',
      type: 'text',
      name: 'Text',
      required: true,
      disabled: isLoading,
      maxLength: 210,
    },
    false
  )

  const handleCourseChange = (selectedOptions) => {
    setSelectedCourse(selectedOptions)
    setCoursesModified(true)
  }

  const handleSubmit = (e) => {
    e.preventDefault()

    let courses = []

    if (coursesModified) {
      courses = selectedCourse.length > 0
        ? selectedCourse.map(vselec => vselec.value)
        : []
    } else {
      courses = courseListToEdit.map(course => course.value)
    }

    const data = {
      name: name.value,
      description: text.value,
      status: checked,
      courses: courses
    }

    onSubmit(data)
  }

  return (
    <div className="form-container">
          <form disabled={isLoading} onSubmit={handleSubmit}>
        
        <div className="form-group">
          <label htmlFor="name-input">Nombre {name.required ? '*' : ''}</label>
          <InputText id="name-input" {...name} />
        </div>

        <div className="form-group">
          <label htmlFor="text-input">Descripción {text.required ? '*' : ''}</label>
          <InputTextarea maxLength={100} id="text-input" {...text} />
        </div>

        <div className="form-group">
          <label htmlFor="type-input">Cursos {course.required ? '*' : ''}</label>

          <Select
            defaultValue={courseListToEdit}
            isMulti
            name="virtualmachine"
            options={courseList}
            className="basic-multi-select"
            id="virtualmachine"
            classNamePrefix="select"
            onChange={handleCourseChange}
          />
        </div>

        <div className="form-group">
          <label htmlFor="estado-input">Estado </label>
          <div className="switch-wrapper">
            <Switch onChange={handleChange} checked={checked} className="react-switch" />
          </div>
        </div>
        <div className="button-group">
          <Button
            label={isLoading ? 'Guardando...' : 'Guardar'}
            disabled={isLoading}
            type="submit"
            className="button primary"
          />
          <Link to={cancelLink} className="button secondary">
            Cancelar
          </Link>
        </div>
      </form>
    </div>
  )
}

ProgramForm.propTypes = {
  item: PropTypes.object,
  isLoading: PropTypes.bool.isRequired,
  onSubmit: PropTypes.func.isRequired,
  cancelLink: PropTypes.string.isRequired,
}
